function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export function ChevronDownIcon(_0) {
    let { color = 'currentColor' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16.3249 10.1675C16.145 9.98125 15.9017 9.87671 15.6481 9.87671C15.3945 9.87671 15.1511 9.98125 14.9713 10.1675L11.5249 13.7075L8.12648 10.1675C7.9466 9.98125 7.70329 9.87671 7.44968 9.87671C7.19605 9.87671 6.95274 9.98125 6.77288 10.1675C6.6829 10.2605 6.61147 10.3711 6.56273 10.4929C6.514 10.6148 6.48891 10.7455 6.48891 10.8775C6.48891 11.0095 6.514 11.1402 6.56273 11.2621C6.61147 11.3839 6.6829 11.4945 6.77288 11.5875L10.8433 15.8275C10.9325 15.9212 11.0387 15.9956 11.1557 16.0464C11.2727 16.0972 11.3982 16.1233 11.5249 16.1233C11.6516 16.1233 11.7771 16.0972 11.8941 16.0464C12.011 15.9956 12.1172 15.9212 12.2065 15.8275L16.3249 11.5875C16.4148 11.4945 16.4863 11.3839 16.535 11.2621C16.5837 11.1402 16.6089 11.0095 16.6089 10.8775C16.6089 10.7455 16.5837 10.6148 16.535 10.4929C16.4863 10.3711 16.4148 10.2605 16.3249 10.1675Z"
        })
    }));
}
